import { render, staticRenderFns } from "./PurchaseFiles.vue?vue&type=template&id=58608b19&scoped=true"
import script from "./PurchaseFiles.vue?vue&type=script&lang=js"
export * from "./PurchaseFiles.vue?vue&type=script&lang=js"
import style0 from "./PurchaseFiles.vue?vue&type=style&index=0&id=58608b19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58608b19",
  null
  
)

export default component.exports